import script from "./AdminVendeurSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminVendeurSearch.vue?vue&type=script&setup=true&lang=ts"

import "./AdminVendeurSearch.vue?vue&type=style&index=0&id=21c507a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c507a0"]])

export default __exports__